import React, { MouseEventHandler } from 'react';

import cn from 'classnames';

import { Color } from 'types/colors';

import './style.scss';

export type TypographyVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'button'
  | 'body'
  | 'small-thick'
  | 'small-thin'
  | 'lp-heading'
  | 'link'
  | 'link-small-thick'
  | 'link-small-thin';

const componentForVariant = (
  variant: TypographyVariant,
  component: 'span' | 'p' | 'div' | undefined,
) => {
  if (component) return component;

  switch (variant) {
    case 'body':
      return 'p';
    case 'button':
    case 'small-thick':
    case 'small-thin':
    case 'link':
    case 'link-small-thick':
    case 'link-small-thin':
    case 'lp-heading':
      return 'span';
    default:
      return variant;
  }
};

interface IProps {
  centered?: boolean;
  children: React.ReactNode;
  className?: string;
  color?: Color;
  component?: 'span' | 'p' | 'div' | undefined;
  language?: string;
  selectable?: boolean;
  testId?: string;
  variant: TypographyVariant;
  wrap?: boolean;
  onClick?: MouseEventHandler;
}

const Typography = ({
  centered,
  children,
  className,
  color,
  component,
  language,
  selectable = true,
  testId,
  variant,
  wrap = false,
  onClick,
}: IProps) => {
  const Component = componentForVariant(variant, component);
  const componentClasses = cn(
    'Typography',
    `Typography--${color || 'white'}`,
    className,
    variant && `Typography--${variant}`,
    {
      'Typography--centered': centered,
    },
    { 'Typography--no-selectable': !selectable },
    { 'Typography--wrap': wrap },
  );

  return (
    <Component
      onClick={onClick}
      className={componentClasses}
      data-testid={testId}
      lang={language}
    >
      {children}
    </Component>
  );
};

export default Typography;
